import { getCommonAnalytics } from '../common-analytics';

const bannerSelector = '#global-banner, [id*="mhecomm-promotional-banner"]';
const initializedAnchors = new WeakSet<HTMLAnchorElement>();

function setAnchorMetadata(anchor: HTMLAnchorElement, metadata: Record<string, unknown>): void {
  Object.entries(metadata).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      anchor.setAttribute(`data-layer-${key}`, String(value));
    }
  });
}

function initializeBanner(banner: Element): void {
  const anchor = banner.querySelector<HTMLAnchorElement>('a');
  if (!anchor || initializedAnchors.has(anchor)) return;

  if (banner.id === 'global-banner') {
    const type = banner.querySelector<HTMLElement>('#global-banner-close-btn')?.dataset.layerType;
    setAnchorMetadata(anchor, {
      comp: 'textlink',
      subarea: 'globalnav',
      name: 'global-banner-link',
      area: 'header',
      type,
    });
  } else {
    const bannerData = getCommonAnalytics(banner);
    setAnchorMetadata(anchor, {
      comp: 'textlink',
      name: 'promotional-banner-link',
      area: 'main',
      label: bannerData.label,
      type: bannerData.type,
    });
  }

  anchor.classList.add('mh-analytic');
  initializedAnchors.add(anchor);
}

export function initializeBannerAnalytics(root: ParentNode = document): void {
  root.querySelectorAll(bannerSelector).forEach(initializeBanner);
}

export function registerBannerAnalytics(): void {
  initializeBannerAnalytics();
  document.addEventListener('DOMContentLoaded', () => initializeBannerAnalytics(), { once: true });
  document.addEventListener('DynamicContentLoaded', () => initializeBannerAnalytics());
}
